var React = require('react');
var ReactNative = require('react-native');
var ReactDOM = require('react-dom')
var createReactClass = require('create-react-class');

var {StyleSheet, View, TextInput, CheckBox} = ReactNative;


import { Button } from 'react-materialize';

var ReUpText = require('../ReUpText');
var Animated = require('./Animated');

var MKButton = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      onPress: ()=>{},
      style:{},
      backgroundColor:null,
      enabled:true,
      disableBorder:true
    }
  },

  componentDidMount : function()
  {
    var element = ReactDOM.findDOMNode(this._button);
    element.setAttribute('tabindex', '-1');
  },

  render : function()
  {
    var {onPress, style, backgroundColor, enabled, disableBorder, ...otherProps} = this.props;

    var newStyle = [];
    newStyle.push({backgroundColor:'transparent'});
    newStyle.push(style);
    if( backgroundColor != null ) newStyle.push({backgroundColor});
    if( disableBorder ) newStyle.push({border:'none'})
    newStyle = StyleSheet.flatten(newStyle);
    newStyle.flexDirection = "column";
    newStyle.alignItems = "stretch";
    newStyle.boxShadow = "0px 0px 5px " + this.props.shadowColor;
    newStyle.cursor = "pointer";
    if( typeof newStyle.marginHorizontal !== 'undefined' && typeof newStyle.marginLeft === 'undefined' ) newStyle.marginLeft = newStyle.marginHorizontal;
    if( typeof newStyle.marginHorizontal !== 'undefined' && typeof newStyle.marginRight === 'undefined' ) newStyle.marginRight = newStyle.marginHorizontal;

    return <Button ref={(a)=>this._button = a} waves='light' onClick={onPress} style={newStyle} disabled={!enabled} {...otherProps} />
  }
})

MKButton.accentColoredFab = function()
{
  var defaultStyle = {width:60, height:60, borderRadius:30, backgroundColor:'red'};
  var button = {
    defaultProps : {
      onPress: ()=>{},
      backgroundColor: null,
      style: {}
    },

    getDefaultProps : function()
    {
      return this.defaultProps;
    },

    componentDidMount : function()
    {
      var element = ReactDOM.findDOMNode(this._button);
      element.setAttribute('tabindex', '-1');
    },

    render : function()
    {
      var {onPress, backgroundColor, style, ...otherProps} = this.props;

      var newStyle = [];
      newStyle.push(style);
      if( backgroundColor != null ) newStyle.push({backgroundColor});
      newStyle.push({border:'none'});
      newStyle = StyleSheet.flatten(newStyle);
      newStyle.cursor = "pointer";

      return <Button ref={(a)=>this._button = a} onClick={onPress} floating large style={newStyle} {...otherProps} />
    }
  };
  button.withStyle = function(style)
  {
    button.defaultProps.style = [defaultStyle, style];

    return button;
  }
  button.build = function()
  {
    return createReactClass(button);
  }

  return button;
}

var MKTextField = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      style:{},
      floatingLabelFont:{},
      textInputStyle:{},
      highlightColor:'transparent',
      tintColor:'transparent',
      password:false,
      onSubmitEditing:()=>{},
      maxLength:100000
    }
  },

  getInitialState : function()
  {
    var state = {};
    state.text = "";
    if( typeof this.props.value !== 'undefined' ) state.text = this.props.value;
    for( var key in this.props ) state[key] = this.props[key];
    state.isFocused = false;

    return state;
  },

  componentWillReceiveProps : function(newProps)
  {
    this.setState(newProps);
  },

  componentDidMount : function()
  {
    var element = ReactDOM.findDOMNode(this._input);
    element.setAttribute('tabindex', '-1');
  },

  focus : function()
  {
    if( this._input ) this._input.focus();
  },

  render : function()
  {
    var thisThing = this;
    var isFocused = this.state.isFocused;
    var otherProps = {};
    if( typeof this.props.keyboardType !== 'undefined' ) otherProps.keyboardType = this.props.keyboardType;

    var showFloating = this.state.text.length > 0;

    return <View key={"container"} style={[this.state.style, {flexDirection:'column', alignItems:'stretch'}]}>
      <View key={"floatingcontainer"} style={{height:12}}>
        <ReUpText style={[this.state.floatingLabelFont, {color:showFloating ? (isFocused ? this.state.highlightColor : this.state.placeholderTextColor) : 'transparent'}]}>{this.state.placeholder}</ReUpText>
      </View>
      <View key={"lowercontainer"} style={{flexDirection:'column', alignItems:'stretch'}}>
        <TextInput ref={(a)=>{if( a != null ) thisThing._input = a;}}
          key={"input"}
          onFocus={()=>
          {
            thisThing.setState({isFocused:true})
          }} onBlur={()=>this.setState({isFocused:false})}
          placeholder={showFloating ? "" : this.state.placeholder}
          style={StyleSheet.flatten([this.state.textInputStyle, {marginBottom:0, width:'100%', borderColor:this.state.tintColor}])}
          value={this.state.text}
          onChangeText={(text)=>
          {
            thisThing.setState({text})
            if( typeof thisThing.props.onChangeText !== 'undefined' ) thisThing.props.onChangeText(text)
          }}
          secureTextEntry={this.state.password}
          onSubmitEditing={this.props.onSubmitEditing}
          tabindex={"-1"}
          maxLength={this.props.maxLength}
          {...otherProps}
          />
          <View style={{height:2, backgroundColor:isFocused ? this.state.highlightColor : this.state.tintColor}} />
      </View>
    </View>
  }
})

var MKSpinner = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      style:{},
    }
  },

  getInitialState : function()
  {
    return {
      rotation:new Animated.Value(0, "spinner"),
    }
  },

  _isMounted: true,
  componentDidMount : function()
  {
    this.startRotation();
  },

  componentWillUnmount : function()
  {
    if( this._animation && this._animation.stop ) this._animation.stop();
  },

  startRotation : function()
  {
    this._animation = Animated.timing(
      this.state.rotation,
      {
        toValue: 360*30,
        duration: 30000
      }
    ).start(function()
    {

    });
  },

  render : function()
  {
    var thisThing = this;
    var borderColors = {}
    if( typeof this.props.strokeColor !== 'undefined' )
    {
      if( this.props.strokeColor.length == 1 ) borderColors.borderTopColor = this.props.strokeColor[0];
      else if( this.props.strokeColor.length == 2 )
      {
        borderColors.borderTopColor = this.props.strokeColor[0];
        borderColors.borderBottomColor = this.props.strokeColor[1];
      }
    }

    return <View style={StyleSheet.flatten([thisThing.props.style, {height:30, width:30}])}>
      <Animated.View style={[{transform: [{ rotate: thisThing.state.rotation}], flex:1, alignSelf:'stretch', borderWidth:2, borderRadius:100, borderColor:'transparent', borderStyle:'solid'}, borderColors]}/>
    </View>
  }
})

var MKCheckbox = createReactClass(
  {
    getDefaultProps : function()
    {
      return {
        style:{flex:-1, width:28, height:28, paddingTop:4},
        checked:false,
        description:null,
        clickHandler:null,
        fillColor:'#000',
        textColor:'black',
        checkboxSideLength: null
      }
    },
  
    getInitialState : function()
    {
      return {
        checked:this.props.checked,
        description:this.props.description,
        style:{flex:-1, width:28, height:28, paddingTop:4},
      }
    },
  
    componentWillReceiveProps : function(newProps)
    {
      if( typeof newProps.clickHandler !== null ){
        this.setState({clickHandler:newProps.clickHandler}); 
      }
    },
  
    componentDidMount : function()
    {
    },
  
    componentWillUnmount : function()
    {
    },
  
    render : function()
    {
      var {style, fillColor, borderOnColor, borderOffColor, borderOffColor, rippleColor, ...otherProps} = this.props;
      var thisThing = this;

      return <View style={[style, {flexDirection:'row', width:'100%'}]}>
        <Button waves='light' style={
        {
          backgroundColor:this.state.checked ? 'transparent' : 'transparent',
          border:'none',
          display:'flex'
        }}
        onClick={()=>
        {
          thisThing.setState({checked:!thisThing.state.checked});
          if(typeof thisThing.props.clickHandler !== null || typeof thisThing.props.clickHandler !== 'undefined') thisThing.props.clickHandler(!thisThing.state.checked);                       

        }}>
          { this.props.checkboxSideLength == null ?
            <CheckBox color={this.props.fillColor} value={thisThing.state.checked} style={{alignSelf:'center'}}/>
          :

            <CheckBox color={this.props.fillColor} value={thisThing.state.checked} style={{height:this.props.checkboxSideLength, width: this.props.checkboxSideLength, alignSelf:'center'}}/>

          }
          
            <View style={{flex:1, display:'flex'}}>
                <ReUpText style={{color:this.props.textColor, paddingLeft: 12}} numberOfLines={3}>{this.props.description}</ReUpText>
            </View>

        </Button>
      </View>
    }
  
  })

var MKIconToggle = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      style:{flex:-1, width:28, height:28, paddingTop:4},
      checked:false,
    }
  },

  getInitialState : function()
  {
    return {
      checked:this.props.checked
    }
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.checked !== 'undefined' ) this.setState({checked:newProps.checked});
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  render : function()
  {
    var {style, fillColor, borderOnColor, borderOffColor, borderOffColor, rippleColor, ...otherProps} = this.props;

    var thisThing = this;
    return <View style={style}>
      <View style={{flex:1}} />
      <Button waves='light' style={
      {
        backgroundColor:this.state.checked ? 'transparent' : 'transparent',
        border:'none',
        flex:-1,
      }}
      onClick={()=>
      {
        var newState = {
          checked:!thisThing.state.checked
        };
        thisThing.setState(newState);
        thisThing.props.onCheckedChange(newState)
      }}>
        {
          this.state.checked ?
          this.props.children[0] : this.props.children[1]
        }
      </Button>
      <View style={{flex:1}} />
    </View>
  }
})

module.exports = {
  MKButton,
  MKTextField,
  MKSpinner,
  MKIconToggle,
  MKCheckbox,
  MKRadioButton : MKCheckbox,
}



// WEBPACK FOOTER //
// ./src/wrappers/react-native-material-kit-wrapper.js